import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  HostListener,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-ui-dropdown',
  templateUrl: './ui-dropdown.component.html',
  styleUrl: './ui-dropdown.component.scss',
  standalone: true,
  imports: [NgIf, NgTemplateOutlet],
})
export class UiDropdownComponent implements AfterViewInit {
  @Input()
  public height = 0;

  @ViewChild('triggerElement')
  public triggerElement!: ElementRef<HTMLElement>;

  @ViewChild('dropdownPanel')
  public dropdownPanel?: ElementRef<HTMLElement>;

  @ContentChild('contentTemplate', { static: true })
  public contentTemplate!: TemplateRef<unknown>;

  public dropdownPosition = {
    left: 0,
    top: 0,
  };
  public isOpen = false;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    this.updateDropdownPosition();
  }

  public toggleDropdown(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.cdr.detectChanges();
      this.updateDropdownPosition();
    }
  }

  public closeDropdown(): void {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.cdr.detectChanges();
  }

  public updateDropdownPosition(): void {
    if (!this.triggerElement) {
      return;
    }

    const triggerRect =
      this.triggerElement.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const dropdownHeight = this.height;
    const isRtl = getComputedStyle(document.body).direction === 'rtl';
    const offset = 4;

    let top = triggerRect.top;
    if (top + dropdownHeight > viewportHeight) {
      top = Math.max(viewportHeight - dropdownHeight - 10, 0);
    }

    let left: number;
    if (isRtl) {
      const dropdownWidth =
        this.dropdownPanel?.nativeElement.offsetWidth ?? 200;
      left = triggerRect.left - dropdownWidth - offset;
      if (left < 0) {
        left = 0;
      }
    } else {
      left = triggerRect.right + offset;
    }

    this.dropdownPosition.left = left;
    this.dropdownPosition.top = top;
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const clickedInsideTrigger = this.triggerElement?.nativeElement.contains(
      event.target as Node,
    );
    const clickedInsidePanel = this.dropdownPanel?.nativeElement.contains(
      event.target as Node,
    );

    if (this.isOpen && !clickedInsideTrigger && !clickedInsidePanel) {
      this.isOpen = false;
    }
  }
}
